import Component from '_core_ext/components/Component';
import eventMgr from '_core_ext/eventMgr';

export default class LoyaltyCardSelection extends Component {

    /**
     * Returns elements' selector for initialize
     * @returns {string}
     */
    static get selector() {
        return '.js-component-loyalty-selection';
    }

    /**
     * Method called when creating component
     * @param {array} args {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Spread_operator}
     */
    init(...args) {
        const loyaltyDisabled = this.$el.data('loyaltyDisabled');   // when disabled for locale - don't do anything
        const loyaltyEnabledCountries = this.$el.data('loyaltyEnabledCountries');

        super.init(...args);

        // Set initial state of loyalty card field
        const $loyaltyInput = this.$el.find('.loyalty-add-card');
        const $inputField = $loyaltyInput.find('.loyaltynumber');
        if ($inputField.length) {
            $loyaltyInput.addClass('hidden');
            $inputField.prop('required', false);
            $inputField.prop('disabled', true);
            $inputField.val('');
        }

        this.event('click', 'input[type="radio"]', (el) => {
            const isRefuseCard = $(el).attr('id') === 'is-REFUSE_CARD';
            const isUpdateCard = $(el).attr('id') === 'is-UPDATE_CARD';

            // Handle birthday field visibility
            $('.js-account-birthday').toggleClass('hidden', isRefuseCard);
            // Handle loyalty card field visibility and validation
            const $loyaltyInput = this.$el.find('.loyalty-add-card');
            const $inputField = $loyaltyInput.find('.loyaltynumber');
            if ($inputField.length) {
                if (isUpdateCard) {
                    $loyaltyInput.removeClass('hidden');
                    $inputField.prop('required', true);
                    $inputField.prop('disabled', false);
                } else {
                    $loyaltyInput.addClass('hidden');
                    $inputField.prop('required', false);
                    $inputField.prop('disabled', true);
                    $inputField.val('');
                }
            }
        });
        // if countries allowed for loyalty are limited and selected by customer does not match,
        // loyalty block will be hidden (from outside) and we should preselect Refuse option here
        if (!loyaltyDisabled && loyaltyEnabledCountries) {
            eventMgr.on('CustomerAddress.countryChanged', (countryCode) => {
                const enabledCountry = (loyaltyEnabledCountries.indexOf(countryCode) > -1);
                if (enabledCountry) {
                    this.$el.find('#is-NEW_CARD').click();
                } else {
                    this.$el.find('#is-REFUSE_CARD').click();
                }
            });
        }
    }

}

module.exports = LoyaltyCardSelection;
